import { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import {
  AddObjectivesActivities,
  EditOneObjectivesActivities,
  GetOneObjectivesActivities,
} from "../../../Redux/Reducers/BudgetInformation/ObjectivesActivities";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import {
  GetObjectivesById,
  GetObObjectives,
} from "../../../Redux/Reducers/BudgetInformation/Objectives";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { setRefreshTable } from "../../../Redux/Reducers/VariousVariables";
import $ from "jquery";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import Swal from "sweetalert2";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
import { useParams } from "react-router-dom";
const ObjectivesActivitiesAddEdit = (props) => {
  const [activity, setActivity] = useState(null);
  const [activityDescription, setActivityDescription] = useState(null);
  // const [schumannsContributionValidation, setSchumannsContributionValidation] = useState(null)

  // const [schumannsContribution, setSchumannsContribution] = useState(null)

  const [bI_ObjectivesId, setBI_ObjectivesId] = useState(null);
  const dispatch = useDispatch();
  const AppGuid = useParams();

  let ObjectivesActivities = useSelector(
    (state) => state.ObjectivesActivities.ObjectivesActivities
  );
  const ObjectivesActivitiesLoding = useSelector(
    (state) => state.ObjectivesActivities.lodingObjectivesActivities
  );
  const [activityValidate, setActivityValidate] = useState(false);
  const [activityDescriptionValidate, setActivityDescriptionValidate] =
    useState(false);

  const [bI_ObjectivesIdValidate, setBI_ObjectivesIdValidate] = useState(false);
  const ObjectivesList = useSelector(
    (state) => state.objectives.ObjectivesList
  );
//to add data on ObjectivesActivities table
  const AddObjectivesActivities_ = async () => {
    if (
      activityDescription != null &&
      activityDescription != "" &&
      activity != null &&
      activity != "" &&
      bI_ObjectivesId != null
      // schumannsContribution!=null
    ) {
      setActivityValidate(false);
      setActivityDescriptionValidate(false);
      setBI_ObjectivesIdValidate(false);
      // setSchumannsContributionValidation(false)
      const ObjectivesActivitie = await dispatch(
        AddObjectivesActivities({
          activityDescription: activityDescription,
          activity: activity,
          bI_ObjectivesId: bI_ObjectivesId,
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          ),
          // schumannsContribution:schumannsContribution
        })
      );
//after add success refresh rable and show popup info
      if (ObjectivesActivitie) {
        dispatch(setRefreshTable());
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم اضافة المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
      }
    } else {
      if (activity == null || activity == "") {
        setActivityValidate(true);
      }
      if (activityDescription == null || activityDescription == "") {
        setActivityDescriptionValidate(true);
      }
      if (bI_ObjectivesId == null) {
        setBI_ObjectivesIdValidate(true);
      }
      // if (schumannsContribution == null|| schumannsContribution == "") {
      //   setSchumannsContributionValidation(true);
      // }
    }
  };
//to update data on ObjectivesActivities
  const EditObjectivesActivities_ = async () => {
    if (
      activityDescription != null &&
      activityDescription != "" &&
      activity != null &&
      activity != "" &&
      bI_ObjectivesId != null
      // schumannsContributionValidation!=null
    ) {
      setActivityValidate(false);
      setActivityDescriptionValidate(false);
      setBI_ObjectivesIdValidate(false);
      // setSchumannsContributionValidation(false)

      const ObjectivesActivitie = await dispatch(
        EditOneObjectivesActivities({
          bI_ObjectiveActivitiesId: props.bI_ObjectiveActivitiesId,
          activityDescription: activityDescription,
          activity: activity,
          // schumannsContribution:schumannsContribution,
          bI_ObjectivesId: bI_ObjectivesId,
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          ),
        })
      );
//popup after add success
      if (ObjectivesActivitie) {
        dispatch(setRefreshTable());
        $(".close-btn").trigger("click");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم تعديل المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
      }
    } else {
      if (activity == null || activity == "") {
        setActivityValidate(true);
      }
      if (activityDescription == null || activityDescription == "") {
        setActivityDescriptionValidate(true);
      }
      if (bI_ObjectivesId == null) {
        setBI_ObjectivesIdValidate(true);
      }

      // if (setSchumannsContribution == null|| setSchumannsContribution == "") {
      //   setSchumannsContributionValidation(true);
      // }
    }
  };
  // Fetch all objectives when the component is mounted
  useEffect(() => {
    dispatch(
      GetObObjectives(
        localStorage.getItem("aI_ApplicationInformationId") ||
          decryptToken(AppGuid.AppGuid) // Retrieve the ID from localStorage or decrypt it
      )
    );
  }, []); // Runs once on component mount

  // Fetch specific objective activity data when the prop `bI_ObjectiveActivitiesId` changes
  useEffect(() => {
    if (props != null) {
      dispatch(
        GetOneObjectivesActivities({
          bI_ObjectiveActivitiesId: props.bI_ObjectiveActivitiesId, // Fetch activity based on its ID
        })
      );
      setBI_ObjectivesId(ObjectivesActivities?.bI_ObjectivesId); // Set the related objective ID
      setActivity(ObjectivesActivities?.activity); // Set the activity name
      setActivityDescription(ObjectivesActivities?.activityDescription); // Set the activity description
    }
  }, [props.bI_ObjectiveActivitiesId]); // Runs when `bI_ObjectiveActivitiesId` changes

  // Update the state with fetched objective activity data or reset when no action is defined
  useEffect(() => {
    if (
      !ObjectivesActivitiesLoding && // Ensure the data has finished loading
      props.Action == "edit" // Check if the action is "edit"
    ) {
      setBI_ObjectivesId(ObjectivesActivities?.bI_ObjectivesId); // Set the related objective ID
      setActivity(ObjectivesActivities?.activity); // Set the activity name
      setActivityDescription(ObjectivesActivities?.activityDescription); // Set the activity description
    } else if (props.Action == undefined) {
      // Reset state if no action is defined
      setBI_ObjectivesId(null); // Clear objective ID
      setActivity(null); // Clear activity name
      setActivityDescription(null); // Clear activity description
      ObjectivesActivities = null; // Reset ObjectivesActivities
    }
  }, [ObjectivesActivities]); // Runs when `ObjectivesActivities` changes

  return (
    <>
      {(props.Action == "edit" && !ObjectivesActivitiesLoding) ||
      (props.Action == "view" && !ObjectivesActivitiesLoding) ||
      props.Action == undefined ? (
        <>
          <div className="containerObjectivesActivitiesAddEdit">
            <AllDropDownsAHSF
              fieldsName="objectiveName"
              show={true}
              disabled={props.disabledData}
              dropdownType="normal"
              arrayOoptionList={ObjectivesList}
              KeyText={"objectiveName"}
              KeyValue={"bI_ObjectivesId"}
              defaultValue={
                props.Action == "view" || props.Action == "edit"
                  ? ObjectivesActivities?.bI_ObjectivesId
                  : ""
              }
              onChange={(e) => {
                setBI_ObjectivesId(parseInt(e.target.value));
              }}
              showValidationMessage={bI_ObjectivesIdValidate}
              validationMessage={"حقل اجباري"}
            />
            <InputAHSF
              fieldsName="activity"
              show={true}
              disabled={props.disabledData}
              defaultValue={
                props.Action == "view" || props.Action == "edit"
                  ? ObjectivesActivities?.activity
                  : ""
              }
              onChange={(e) => {
                setActivity(e.target.value);
              }}
              showValidationMessage={activityValidate}
              validationMessage={"حقل اجباري"}
            />
            <InputAHSF
              fieldsName="activityDescription"
              show={true}
              disabled={props.disabledData}
              defaultValue={
                props.Action == "view" || props.Action == "edit"
                  ? ObjectivesActivities?.activityDescription
                  : ""
              }
              onChange={(e) => {
                setActivityDescription(e.target.value);
              }}
              showValidationMessage={activityDescriptionValidate}
              validationMessage={"حقل اجباري"}
            />
             {/* <InputAHSF
              fieldsName="schumannsContribution"
              show={true}
              disabled={props.disabledData}
              defaultValue={
                props.Action == "view" || props.Action == "edit"
                  ? ObjectivesActivities?.schumannsContribution
                  : ""
              }
              onChange={(e) => {
                setSchumannsContribution(e.target.value);
              }}
              showValidationMessage={schumannsContributionValidation}
              validationMessage={"حقل اجباري"}
            /> */}
          </div>
          <div className="containerButton">
            {props.Action == "view" ? (
              <></>
            ) : (
              <ButtonAHSF
                onClick={
                  props.Action == "edit"
                    ? EditObjectivesActivities_
                    : AddObjectivesActivities_
                }
                text={"حفظ"}
                show={true}
              />
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={ObjectivesActivitiesLoding} />
    </>
  );
};

export default ObjectivesActivitiesAddEdit;
